export function appPath(path: string) {
  const root = document.documentElement.dataset.relativeUrlRoot?.replace(/\/+$/, "") || "";
  return `${root}${path.startsWith("/") ? path : `/${path}`}`;
}
